import DashboardLayout from '@/components/dashboard/dashboard-layout/dashboard-layout';
import IconCatch from '@/components/icons/icon-catch/icon-catch';
import { ROUTE_BUILD_ACTION_PLAN } from '@/constants/routes';
import useIsMobile from '@/hooks/use-is-mobile';
import { Flex, Link, Text } from '@cmpsr/components';
import { Link as ReactRouterLink } from 'react-router-dom';

type EmptyStateProps = {
  name?: string;
};

export default function EmptyState({ name }: EmptyStateProps) {
  const isMobile = useIsMobile();
  const size = isMobile ? 's' : 'm';

  return (
    <DashboardLayout>
      <Flex as="main" justifyContent="center" alignItems="center" pt={{ base: 8, md: 10, lg: 12 }}>
        <Flex
          direction="column"
          justify="center"
          alignItems="center"
          backgroundColor="primary-default"
          w="1184px"
          py={{ base: '20px', lg: '64px' }}
          px={{ base: '16px', lg: '48px' }}
          borderRadius="radii-3"
        >
          <IconCatch
            icon="task-list-edit"
            backgroundColor="primary-hover"
            borderRadius="10px"
            size={isMobile ? 'l' : 'xl'}
            alt="Task List icon"
          />
          <Text variant="text-header-2XL" color="text-light" mt={{ base: 'spacer-8', lg: 'spacer-12' }}>
            {name ? (
              <>
                Hi{' '}
                <Text as="span" textStyle="text-header-2xl-v" color="text-light">
                  {name},
                </Text>
              </>
            ) : undefined}
          </Text>
          <Text variant="text-header-2XL" color="text-light" textAlign="center">
            Welcome to your Action Plan Builder
          </Text>
          <Text color="text-light" textAlign="center" variant="text-body-regular" mt="20px">
            Our recommendations are personalized based on your unique risk profile, and prioritized to maximize risk
            reduction. We recommend starting with fewer actions to ensure successful behavioral change. You will have
            the option to add more items as you make progress.
          </Text>
          <Link
            display="flex"
            justifyContent="center"
            as={ReactRouterLink}
            to={ROUTE_BUILD_ACTION_PLAN}
            mt="48px"
            variant="accent"
            size={size}
            w={{ base: 'full', lg: 'auto' }}
          >
            Build your Action Plan
          </Link>
        </Flex>
      </Flex>
    </DashboardLayout>
  );
}
